import React from "react";
import { SlideShell } from "../../../shared/components/SlideShell";

export const Slide8 = ({ t, total, onActive }) => {
  return (
    <SlideShell theme="emissor"
      index={7}
      total={total}
      label="SPED Factory"
      kicker={t.kicker}
      onActive={onActive}
      variant="plain"
      bgStyle={{
        "--slide-bg": "linear-gradient(120deg,#020202,#07110d 52%,#020202),radial-gradient(620px 460px at 74% 46%,rgba(216,182,46,.24),transparent 70%)"
      }}
    >

      <h2>{t.title}</h2>
      <p className="lead">{t.body}</p>

      <table className="matrix">
        <thead>
          <tr>
            <th>{t.tableH1}</th>
            <th>{t.tableH2}</th>
            <th>{t.tableH3}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{t.r1C1}</td>
            <td>{t.r1C2}</td>
            <td><span className="coverage">{t.covered}</span></td>
          </tr>
          <tr>
            <td>{t.r2C1}</td>
            <td>{t.r2C2}</td>
            <td><span className="coverage">{t.covered}</span></td>
          </tr>
          <tr>
            <td>{t.r3C1}</td>
            <td>{t.r3C2}</td>
            <td><span className="coverage">{t.covered}</span></td>
          </tr>
          <tr>
            <td>{t.r4C1}</td>
            <td>{t.r4C2}</td>
            <td><span className="coverage">{t.covered}</span></td>
          </tr>
        </tbody>
      </table>
    </SlideShell>
  );
};





